import React, { Fragment } from "react";

import {
  Tooltip,
  IconButton,
  withStyles,
  OutlinedInput,
  InputAdornment,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core";

import { Search } from "./CustomButton";

import { palette } from "../../theme";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        borderRadius: 10,
        backgroundColor: palette.normalTextfield,
        border: "none",
        width: 288,
        height: 40,
        caretColor: palette.blue,
        fontSize: 14,
        "&$disabled": { backgroundColor: palette.disabledTextfield },
        "&$focused": { backgroundColor: palette.typingTextfield },
        "&$error": { backgroundColor: palette.errorTextfield },
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
          {
            "-webkit-appearance": "none",
            margin: 0,
          },
      },
      input: {
        padding: 0,
        paddingLeft: 16,
        paddingRight: 16,
      },
      notchedOutline: {
        border: "none",
      },
      adornedStart: {
        color: palette.secondaryText,
      },
      adornedEnd: {
        color: palette.secondaryText,
      },
      inputAdornedStart: {
        paddingLeft: 8,
      },
    },
  },
});

const SearchField = ({ ...props }) => {
  const { classes } = props;
  return (
    <Fragment>
      <MuiThemeProvider theme={theme}>
        <Tooltip title="Search" placement="bottom" arrow>
          <OutlinedInput
            {...props}
            className={classes.input}
            endAdornment={
              <InputAdornment disablePointerEvents position="end">
                <IconButton>
                  <Search />
                </IconButton>
              </InputAdornment>
            }
          />
        </Tooltip>
      </MuiThemeProvider>
    </Fragment>
  );
};

const SearchBar = withStyles((theme) => ({
  input: {
    width: 400,
    marginRight: 10,
  },
}))(SearchField);

export default SearchBar;
